import React, { useState } from 'react'
import Carousel from 'react-bootstrap/Carousel'
import './carousel.css'

const SliderCarousel = () => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    const nextImage = () => {
        const nextIndex = (index + 1) % 6; // 6 items in the carousel
        setIndex(nextIndex);
    }

    return (
        <div className='Wrapper'>
            <Carousel
                fade
                pause={false}
                interval={2500}
                indicators={false}
                controls={false}
                className='Carousel'
                activeIndex={index}
                onSelect={handleSelect}
            >

                <Carousel.Item onClick={nextImage}>
                    <img
                        className="d-block"
                        src="/images/table/Philippe-Starck.webp"
                        alt="Philippe Starck portrait"
                    />
                </Carousel.Item>

                <Carousel.Item onClick={nextImage}>
                    <img
                        className="d-block"
                        src="/images/table/Ron-Arad.webp"
                        alt="Ron Arad portrait"
                    />
                </Carousel.Item>

                <Carousel.Item onClick={nextImage}>
                    <img
                        className="d-block"
                        src="/images/table/Lord-Bath.webp"
                        alt="Lord Bath portrait"
                    />
                </Carousel.Item>

                <Carousel.Item onClick={nextImage}>
                    <img
                        className="d-block"
                        src="/images/table/Eileen.webp"
                        alt="Eileen portrait"
                    />
                </Carousel.Item>

                <Carousel.Item onClick={nextImage}>
                    <img
                        className="d-block"
                        src="/images/table/Harry-&-Joan-On-Holiday.webp"
                        alt="Harry and Joan on holiday"
                    />
                </Carousel.Item>

                <Carousel.Item onClick={nextImage}>
                    <img
                        className="d-block"
                        src="/images/table/Marcel-Wanders.webp"
                        alt="Marcel Wanders portrait"
                    />
                </Carousel.Item>

            </Carousel>
            <a href="//www.instagram.com/jonathanroot" target="_blank" rel="noreferrer" className="mobile-insta-link">
                @jonathanroot
            </a>
        </div>
    )
}

export default SliderCarousel